if (!customElements.get('naked-size-guide')) {
  customElements.define(
    'naked-size-guide',
    class NakedSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const opener = this.querySelector('[data-naked-open]');
        const dialog = this.querySelector('dialog');
        const close = this.querySelector('[data-naked-close]');
        const form = this.querySelector('[data-naked-form]');
        const input = this.querySelector('[data-naked-measure]');
        const recommendation = this.querySelector('[data-naked-recommendation]');
        const feedback = Array.from(this.querySelectorAll('[data-naked-feedback]'));
        const sizes = Array.from(this.querySelectorAll('[data-naked-size][data-naked-cm]'))
          .map((row) => ({ size: row.dataset.nakedSize, cm: Number(row.dataset.nakedCm) }))
          .filter((row) => row.size && Number.isFinite(row.cm))
          .sort((a, b) => a.cm - b.cm);

        if (!opener || !dialog || !close || !form || !input || !recommendation || !sizes.length) return;

        opener.addEventListener('click', () => {
          dialog.showModal();
          input.focus();
        });
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => opener.focus());

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          feedback.forEach((item) => { item.hidden = true; });

          const entered = input.value.trim().replace(',', '.');
          const measured = Number(entered);
          if (!entered || !Number.isFinite(measured) || measured <= 0) {
            this.querySelector('[data-naked-feedback="invalid"]').hidden = false;
            return;
          }

          if (measured < sizes[0].cm || measured > sizes[sizes.length - 1].cm) {
            this.querySelector('[data-naked-feedback="outside"]').hidden = false;
            return;
          }

          const match = sizes.find((size) => measured <= size.cm);
          const formatted = new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {
            maximumFractionDigits: 1,
          }).format(match.cm);
          recommendation.textContent = `${match.size} (${formatted} cm)`;
          this.querySelector('[data-naked-feedback="recommended"]').hidden = false;
        });
      }
    }
  );
}
